import React from "react";
import { Sparkles } from "lucide-react";

export default function PlcspAiBanner({ interpretation, keywords = [], cpvCodes = [] }) {
    if (!interpretation) return null;
    return (
        <div
            className="bg-gradient-to-r from-violet-50 to-fuchsia-50 border border-violet-200 rounded-2xl p-4 mb-4 shadow-pop"
            data-testid="plcsp-ai-banner"
        >
            <div className="flex items-start gap-3">
                <Sparkles size={18} className="text-violet-600 mt-0.5 shrink-0" />
                <div className="flex-1 min-w-0">
                    <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-violet-700 mb-1">
                        Búsqueda IA · {interpretation}
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                        {keywords.slice(0, 12).map((k, idx) => (
                            <span
                                key={`kw-${idx}`}
                                className="text-[11px] font-bold text-violet-700 bg-white border border-violet-200 px-2 py-0.5 rounded-full"
                            >
                                {k}
                            </span>
                        ))}
                        {cpvCodes.slice(0, 6).map((c, idx) => (
                            <span
                                key={`cpv-${idx}`}
                                className="text-[11px] font-mono font-bold text-fuchsia-700 bg-white border border-fuchsia-200 px-2 py-0.5 rounded-full"
                            >
                                CPV {c}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
